import { useEffect, useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import FiltersMenu from '../../../components/filters-menu/FiltersMenu';
import { useCompanyContext } from '../../../context/CompanyContext';
import { useSearchParams } from 'react-router-dom';
import { ProcessContextProvider } from '../../../context/ProcessContext';
import PayPeriodDates from '../../../features/accounting/forms/PayrollTimesheet/PayPeriodDates';
import PRTimesheetParams from '../../../features/accounting/forms/PayrollTimesheet/PRTimesheetParams';
import TimesheetFilters, {
  PRTimesheetFilters,
} from '../../../features/accounting/forms/PayrollTimesheet/TimesheetFilters';
import TimesheetReport from '../../../features/accounting/forms/PayrollTimesheet/report/TimesheetReport';
import TimesheetReportHeader from '../../../features/accounting/forms/PayrollTimesheet/report/TimesheetReportHeader';
import TimeSheetTableContainer from '../../../features/accounting/forms/PayrollTimesheet/TimesheetTableContainer';
import TimesheetTemplate from '../../../features/accounting/forms/PayrollTimesheet/TimesheetTemplate';
import { TimeSheetArgs } from '../../../Interfaces/Accounting/ACForms.interfaces';

const PayrollTimesheet = () => {
  const { selectedCompany } = useCompanyContext();
  const [searchParams] = useSearchParams();
  const [periodStart, setPeriodStart] = useState<Date>();
  const [periodEnd, setPeriodEnd] = useState<Date>();
  const [timesheetTemplate, setTimesheetTemplate] = useState<TimeSheetArgs>();
  const [defaultLoading, setDefaultLoading] = useState<boolean>(false);
  const methods = useForm<PRTimesheetFilters>();
  const tableRef = useRef<HTMLDivElement | null>(null);
  const prevSelectedCompanyRef = useRef<string | null>(null);

  const changeDates = (periodStart: Date, periodEnd: Date) => {
    setPeriodStart(periodStart);
    setPeriodEnd(periodEnd);
  };

  useEffect(() => {
    if (prevSelectedCompanyRef.current === null) {
      prevSelectedCompanyRef.current = selectedCompany?.id || null;
    } else if (prevSelectedCompanyRef.current !== selectedCompany?.id) {
      if (!searchParams.get('company')) {
        methods.reset();
      }
      prevSelectedCompanyRef.current = selectedCompany?.id || null;
    }
  }, [selectedCompany, methods, searchParams]);

  return (
    <div className="flex flex-column justify-content-center gap-2 pt-4">
      <div className="text-35px font-bold text-center mb-2">
        New Payroll Timesheet
      </div>
      <div>
        <PayPeriodDates storeDates={changeDates} />
      </div>
      <div className="mx-3 mt-3">
        <TimesheetTemplate
          storeTemplate={(value) => {
            setTimesheetTemplate(value);
          }}
          updateLoading={(value) => {
            setDefaultLoading(value);
          }}
        />
      </div>
      <FormProvider {...methods}>
        <div className="mt-3 px-3 flex w-full justify-content-between">
          <FiltersMenu>
            <TimesheetFilters />
          </FiltersMenu>
          <TimesheetReport
            elementRef={tableRef}
            periodStart={periodStart!}
            periodEnd={periodEnd!}
          />
        </div>
        <div className="mt-1 printBackground pdfDivFitContent" ref={tableRef}>
          {
            <TimesheetReportHeader
              periodStart={periodStart!}
              periodEnd={periodEnd!}
            />
          }
          <ProcessContextProvider>
            <TimeSheetTableContainer
              periodStart={periodStart!}
              periodEnd={periodEnd!}
              defaultTimesheet={timesheetTemplate}
              defaultLoading={defaultLoading}
            />
          </ProcessContextProvider>
        </div>
        <PRTimesheetParams />
      </FormProvider>
    </div>
  );
};

export default PayrollTimesheet;
